import React from 'react';
import { MapPin, Navigation, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ServiceArea() {
  const prioritySuburbs = ['Gosnells', 'Huntingdale', 'Thornlie', 'Maddington', 'Southern River', 'Harrisdale', 'Leeming', 'Cockburn'];
  return <section className="py-24 lg:py-32 bg-cream relative overflow-hidden" data-id="element-492">
      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-493">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-494">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="order-2 lg:order-1" data-id="element-495">
            <div className="inline-flex items-center gap-2 bg-orange/10 text-orange px-5 py-2.5 rounded-full font-bold text-sm mb-8 border border-orange/20" data-id="element-496">
              <MapPin className="w-4 h-4" data-id="element-497" />
              Local & Reliable
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-navy mb-8 tracking-tighter leading-[1.1]" data-id="element-498">
              Based in Huntingdale, Serving Perth's South
            </h2>

            <p className="text-lg text-slate mb-10 leading-relaxed" data-id="element-499">
              When you need an electrician, you want someone local who can
              arrive quickly. Our Huntingdale base puts us right in the heart of
              Perth's south, ensuring fast response times for both emergencies
              and planned projects across the SOR region.
            </p>

            <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm mb-10" data-id="element-500">
              <h3 className="text-xl font-heading font-extrabold text-navy mb-6 flex items-center gap-3" data-id="element-501">
                <Navigation className="w-6 h-6 text-orange" data-id="element-502" />
                Priority Service Areas
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-503">
                {prioritySuburbs.map((suburb, index) => <span key={index} className="bg-cream border border-gray-200 text-navy px-5 py-2.5 rounded-lg text-sm font-bold hover:border-orange hover:text-orange transition-colors cursor-default" data-id="element-504">
                    {suburb}
                  </span>)}
                <span className="bg-navy text-white px-5 py-2.5 rounded-lg text-sm font-bold shadow-md" data-id="element-505">
                  + Mandurah & Golden Bay
                </span>
              </div>
            </div>

            <a href="#contact" className="inline-flex items-center gap-2 text-orange font-extrabold text-lg hover:text-orange-600 transition-colors group" data-id="element-506">
              Check if we service your area
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-507" />
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2,
          type: 'spring'
        }} className="order-1 lg:order-2 relative flex items-center justify-center min-h-[400px]" data-id="element-508">
            {/* Decorative circles */}
            <div className="absolute w-[90%] h-[90%] rounded-full border-2 border-orange/10 z-0" data-id="element-509"></div>
            <div className="absolute w-[70%] h-[70%] rounded-full border-2 border-orange/15 z-0" data-id="element-510"></div>
            <div className="absolute w-[50%] h-[50%] rounded-full border-2 border-orange/20 bg-orange/5 z-0" data-id="element-511"></div>

            {/* Central Logo & Badge */}
            <div className="relative z-10 flex flex-col items-center" data-id="element-512">
              <div className="w-40 h-40 bg-white rounded-full shadow-2xl flex items-center justify-center border-4 border-orange/20 mb-6" data-id="element-513">
                <img src="https://cdn.magicpatterns.com/uploads/keXDJJ6XdrR4HdR9pRaeSp/pasted-image.png" alt="Completely Electrical" className="w-24 h-24 object-contain" data-id="element-514" />
              </div>
              <div className="bg-navy text-white px-6 py-3 rounded-xl text-sm font-bold shadow-lg flex items-center gap-2" data-id="element-515">
                <MapPin className="w-4 h-4 text-orange" data-id="element-516" />
                Serving Perth's entire south side
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}